import React, { useRef } from "react";
import { CATEGORIES } from "@/lib/stayCategories";

export const CategoryTabs = ({ category, setCategory, pill = false }) => {
  const scroller = useRef(null);

  if (pill) {
    return (
      <div className="flex items-center gap-2 overflow-x-auto no-scrollbar px-4 py-2.5" data-testid="category-pills">
        {CATEGORIES.map((c) => {
          const Icon = c.icon;
          const active = category === c.id;
          return (
            <button key={c.id} onClick={() => setCategory(c.id)} data-testid={`category-pill-${c.id}`} aria-pressed={active}
              className={`shrink-0 inline-flex items-center gap-1.5 rounded-full h-9 px-3.5 text-[13px] font-semibold transition-colors active:scale-95 ${
                active ? "bg-ink text-white" : "bg-white border border-black/10 text-ink-soft"
              }`}>
              <Icon className={`w-4 h-4 ${active ? "text-white" : "text-brand"}`} aria-hidden="true" />
              {c.label}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div ref={scroller} className="flex items-center gap-1.5 overflow-x-auto no-scrollbar -mx-1 px-1" data-testid="category-tabs">
      {CATEGORIES.map((c) => {
        const Icon = c.icon;
        const active = category === c.id;
        return (
          <button
            key={c.id}
            onClick={() => setCategory(c.id)}
            data-testid={`category-${c.id}`}
            aria-pressed={active}
            className={`group shrink-0 inline-flex flex-col items-center gap-1.5 px-3 pt-1.5 pb-2 border-b-2 transition-colors ${
              active ? "border-brand text-ink" : "border-transparent text-ink-faint hover:text-ink"
            }`}
          >
            <Icon className={`w-5 h-5 transition-colors ${active ? "text-brand" : "text-ink-faint group-hover:text-ink"}`} aria-hidden="true" />
            <span className="text-xs font-semibold whitespace-nowrap">{c.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default CategoryTabs;
